import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select, Input } from '@driftt/tide-core-legacy'
import debounce from 'lodash.debounce'

class MarketoProgramSelect extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedProgram: '',
      assignOnlyOnCreate: false,
      fieldOptions: [],
      isLoading: false
    }

    this.updateSelectOptions = debounce(this._updateSelectOptions, 1000)
  }

  componentDidMount() {
    this.getSelectedProgram()
    this.fetchAllPrograms()
    this.updateSelectOptions("")
  }

  getSelectedProgram = async () => {
    const { getSelectedProgram } = this.props

    try {
      const program = await getSelectedProgram()

      const programName = program.campaignId
      const assignOnlyOnCreate = program.assignOnlyOnCreate

      this.setState({
        selectedProgram: programName,
        assignOnlyOnCreate: assignOnlyOnCreate
      })
    } catch(e) {
      console.warn(e)
    }
  }

  _updateSelectOptions = async (query) => {
    const { queryPrograms } = this.props
    const { selectedProgram } = this.state

    try {
      const programs = await queryPrograms(query)
      let programNames = new Set(programs.map(function (program) { return program.name }))

      if (selectedProgram != '') {
        programNames = programNames.add(selectedProgram)
      }

      const options = Array.from(programNames).map(function (programName) { return ({ label: programName, value: programName }) })

      this.setState({
        fieldOptions: options,
        isLoading: false
      })
    } catch(e) {
      console.warn(e)
      this.setState({ isLoading: false })
    }
  }

  fetchAllPrograms = async () => {
    const { fetchPrograms } = this.props

    this.setState({ isLoading: true })

    try {
      await fetchPrograms()
    } catch(e) {
      console.warn(e)
      this.setState({ isLoading: false })
    }
  }

  setProgram = async () => {
    const { onSuccess, setProgram } = this.props
    const { selectedProgram, assignOnlyOnCreate } = this.state

    try {
      await setProgram(selectedProgram, assignOnlyOnCreate)
      onSuccess()
    } catch(e) {
      console.warn(e)
    }
  }

  deleteProgram = async () => {
    const { onSuccess, deleteProgram } = this.props

    try {
      await deleteProgram()
      onSuccess()
    }
    catch(e) {
      console.warn(e)
    }
  }

  handleSelectChange = selectedOption => {
    let newValue

    const selectionCleared = !selectedOption
    if (selectionCleared) {
      newValue = ''
      this.setState({
        selectedProgram: newValue,
        assignOnlyOnCreate: false
      }, this.deleteProgram)
    } else {
      newValue = selectedOption.value
      this.setState({
        selectedProgram: newValue
      }, this.setProgram)
    }
  }

  handleCheckboxChange = newValue => {
    this.setState({
      assignOnlyOnCreate: newValue
    }, this.setProgram)
  }

  render() {
    const { selectedProgram, assignOnlyOnCreate, fieldOptions, isLoading } = this.state

    return (
      <div>
        <Select 
          className={'marketo-program-select'}
          options={fieldOptions}
          value={selectedProgram}
          onChange={this.handleSelectChange}
          onInputChange={this.updateSelectOptions}
          isLoading={isLoading}
        />
        <Input
          className={'marketo-program-checkbox'}
          onChange={this.handleCheckboxChange}
          type="checkbox"
          label={`Only associate net new leads with this program`}
          checked={assignOnlyOnCreate}
        />
      </div>
    )
  }
}

MarketoProgramSelect.propTypes = {
  fetchPrograms: PropTypes.func.isRequired,
  queryPrograms: PropTypes.func.isRequired,
  getSelectedProgram: PropTypes.func.isRequired,
  setProgram: PropTypes.func.isRequired,
  deleteProgram: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired
}

export default MarketoProgramSelect


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MarketoConfig/MarketoProgramSelect.js